var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavyMountains01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#27ade3;}.d{fill:#77b027;}.e{fill:#558a11;}.f{fill:#416e06;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 48,
    height: 48,
    rx: 12
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wavyMountains") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: -7,
    y: -3,
    width: 63,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M55.5,36a117.1,117.1,0,0,0-10-11C35.2,14.9,27.7,7.1,18.5,8c-5.3.5-9.2,3.1-12,5-11.7,7.9-15.7,20.5-17,26V56l66-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-3,32C.2,24.3,1.3,19.1,4,19c5.3-.3,7.1,19,15,20s8.8-11.3,19-13c8.2-1.3,16.1,5,20,10s8.4,14,5,21c-1.2,2.5-5,7.7-46,9-30.7,1-34-1.7-35-4C-20.3,56.8-11.5,52.4-3,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1.2,51.3c-.1-1.5,13.4.4,22-9,6-6.7,3.6-12.4,11-19,1.9-1.8,8.2-7.5,16-6,6.1,1.1,9.6,6.1,11,8,3.5,5,5.9,12.8,4,18C58.7,60.6,1.3,54.2,1.2,51.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyMountains01);
export default __webpack_public_path__ + "static/media/wavyMountains-01.8a1ac1495d93e42117f6a37d18bdd48c.svg";
export { ForwardRef as ReactComponent };